import { usePaginatedMasterData } from './usePaginatedMasterData';
import { getTeams } from '../services/teamService';
import type { TeamListFilters, TeamListItem } from '../types/team';
import { activeConfigurationFilters } from '../utils/configurationFilters';

const EMPTY_FILTERS: TeamListFilters = activeConfigurationFilters();

export function useTeams() {
  return usePaginatedMasterData<TeamListItem, TeamListFilters>({
    getId: item => item.teamId,
    initialFilters: EMPTY_FILTERS,
    errorMessage: 'Unable to load teams.',
    loadPage: async ({ page, pageSize, search, filters }) =>
      getTeams({
        page,
        pageSize,
        filters: {
          ...filters,
          search: search || undefined,
        },
      }),
  });
}
